import React from 'react';
import { converter } from 'helpers/converter';
import PropTypes from 'prop-types';
import constants from './constants';

export const ButtonFav = props => {
  const {
    isFavorite,
    isLoading,
    data,
    user,
    translations,
    handlerAddFavorite,
    handlerDeleteFavorite,
  } = props;
  const params = {
    object_id: data.id,
    user_hash: user.userhash,
    object_type: 1,
  };
  return (
    <div
      role="tooltip"
      type="button"
      style={{ cursor: 'pointer' }}
      onClick={() => {
        if (isLoading) {
          return;
        }
        if (!isFavorite) {
          handlerAddFavorite(params, data);
        } else {
          handlerDeleteFavorite(params, data);
        }
      }}
    >
      <div className="item-btn-wrapper">
        <div className="btn btn-default btn-circle btn-lg item-fanbutton">
          {isLoading && <i className="fa fa-refresh fa-spin" />}
          {!isLoading && !isFavorite && <i className="fa fa-plus" />}
          {!isLoading && isFavorite && <i className="fa fa-minus" />}
        </div>
      </div>
      <div className="item-btn-wrapper">
        <span className="padding-top-05">
          {converter.convertApa(translations, constants.GROUP_BUTTON_ADDFAN)}
        </span>
      </div>
    </div>
  );
};

ButtonFav.propTypes = {
  translations: PropTypes.object,
  handlerAddFavorite: PropTypes.func,
  handlerDeleteFavorite: PropTypes.func,
  data: PropTypes.object,
  user: PropTypes.object,
  isFavorite: PropTypes.bool,
  isLoading: PropTypes.bool,
};
